import Vue from 'vue/dist/vue.js';
import VueRouter from 'vue-router'
import VueSimpleMarkdown from 'vue-simple-markdown'

// 静态资源导入
import statpointLogo from './assets/icon_statpoint_logo.png'
import i18n from './i18n'

import VueLoading from 'vue-loading-template'

// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'vue-simple-markdown/dist/vue-simple-markdown.css'
import './assets/tailwind.css'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(VueSimpleMarkdown)
Vue.use(VueLoading)

// 使用动态导入实现路由懒加载
// webpackChunkName 注释用于指定生成的 chunk 文件名
const routes = [
  { name: 'index', path: '/', component: () => import(/* webpackChunkName: "basboard-index" */ './pages/index/Index.vue') },
  { name: 'tacticDetail', path: '/tactic/:id', component: () => import(/* webpackChunkName: "basboard-preview" */ './pages/preview/Preview.vue') },
  { name: 'privacy', path: '/privacy', component: () => import(/* webpackChunkName: "basboard-privacy" */ './pages/privacy/Privacy.vue') },
  { name: 'agreement', path: '/agreement', component: () => import(/* webpackChunkName: "basboard-agreement" */ './pages/agreement/Agreement.vue') },
  { name: 'memberAgreement', path: '/memberAgreement', component: () => import(/* webpackChunkName: "basboard-member-agreement" */ './pages/member_agreement/MemberAgreement.vue') },
  { name: 'PrivacySDKList', path: '/privacySDKList', component: () => import(/* webpackChunkName: "basboard-privacy-sdk" */ './pages/privacy_sdk_list/PrivacySDKList.vue') },

  { name: 'basketballLib', path: '/library/basketball', component: () => import(/* webpackChunkName: "library-basketball" */ './pages/library/basketball/BaseketballLibrary.vue') },

  { name: 'traincordIndex', path: '/traincord/index', component: () => import(/* webpackChunkName: "traincord-index" */ './pages/traincord/index/Index.vue') },
  { name: 'traincordAgreement', path: '/traincord/agreement', component: () => import(/* webpackChunkName: "traincord-agreement" */ './pages/traincord/agreement/Agreement.vue') },
  { name: 'traincordPrivacy', path: '/traincord/privacy', component: () => import(/* webpackChunkName: "traincord-privacy" */ './pages/traincord/privacy/Privacy.vue') },

  { name: 'statpointIndex', path: '/statpoint', component: () => import(/* webpackChunkName: "statpoint-index" */ './pages/statpoint/index/Index.vue') },
  { name: 'statpointAgreement', path: '/statpoint/agreement', component: () => import(/* webpackChunkName: "statpoint-agreement" */ './pages/statpoint/agreement/Agreement.vue') },
  { name: 'statpointPrivacy', path: '/statpoint/privacy', component: () => import(/* webpackChunkName: "statpoint-privacy" */ './pages/statpoint/privacy/Privacy.vue') },
  { path: '/statpoint/*', redirect: '/statpoint' },

  { name: '404', path: '*', component: () => import(/* webpackChunkName: "basboard-index" */ './pages/index/Index.vue') }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

let isZh = navigator.language.indexOf("zh") >= 0
const titles = {
  basboard: isZh ? "战篮" : "Basboard",
  traincord: isZh ? "练志" : "TrainCord",
  statpoint: isZh ? "赛点" : "StatPoint"
}
router.beforeEach((to, from, next) => {
  let isTraincordPage = to.path.includes("traincord")
  let isStatPointPage = to.path.includes("statpoint")

  // Update Favicon
  const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';

  if (isStatPointPage) {
    link.href = statpointLogo;
  } else {
    link.href = '/favicon.ico';
  }
  document.getElementsByTagName('head')[0].appendChild(link);

  let rootName = "温州上场科技有限公司"
  if (to.path === "/") {
    document.title = rootName
  } else {
    let title = titles.basboard
    if (isTraincordPage) {
      title = titles.traincord
    } else if (isStatPointPage) {
      title = titles.statpoint
    }
    document.title = to.meta.title || title
  }
  next()
})

new Vue({
  router,
  i18n
}).$mount('#app')
